import { List } from "antd";

import { useSelector } from "react-redux";
import {
  GetCustomerCurrentTime,
  pad,
} from "../../../../services/common/cnc_apis";
import lang from "../../../../services/lang";

function HistoryContainer(props) {
  const { langIndex } = useSelector((x) => x.app);

  const {
    customerInfo,
    setCurrentDate,
    currentDate,
    todayString,
  } = props;
  let dateArray = [""];
  for (var i = 1; i < 30; i++) {
    var c = GetCustomerCurrentTime(customerInfo["timezone"]);
    c.setDate(c.getDate() - i);
    dateArray.push(
      pad(c.getMonth() + 1) + "/" + pad(c.getDate()) + "/" + c.getFullYear()
    );
  }

  const onSelectDate = (date) => {
    // Parent handles fetching when currentDate changes.
    setCurrentDate(date);
  };

  return (
    <div className="history-container">
      <div style={{ borderBottom: "1px solid white", textAlign: "left" }}>
        <h3 style={{ color: "white" }}>{lang(langIndex, "cnc_history")}</h3>
      </div>
      <div
        className="content-scrollbar-style menu-container"
        style={{ maxHeight: 180, overflow: "auto", marginTop: 3 }}
      >
        <List
          header={null}
          footer={null}
          //  bordered
          dataSource={dateArray}
          size={"small"}
          renderItem={(item) => {
            return (
              <List.Item
                className={
                  item === currentDate
                    ? "history-item history-item-selected"
                    : "history-item"
                }
                onClick={() => {
                  onSelectDate(item);
                }}
                style={{ height: 35, borderColor: "#333333" }}
              >
                {item === "" ? todayString : item}
              </List.Item>
            );
          }}
        />
      </div>
    </div>
  );
}

export default HistoryContainer;
